export class Code_Model {
    constructor(program_id= 1,branch_id,course,course_ids,gift,id,is_center,type,value,name, typeCode, startDate, endDate, description,unit,amount,isGift = false,isUseGift = false, payment_deadline, payment_value, truong_hoc = [], installment_fee_payer = null, installment_fee = null, discount_method = null, course_discount = null) {
        this.nameCode = name;
        this.typeCode = typeCode;
        this.startDate = startDate;
        this.endDate = endDate;
        this.description = description;
        this.unit = unit;
        this.isGift = isGift;
        this.amount = amount;
        this.selected = false;
        this.hidden = false;
        this.isUseGift = isUseGift;
        this.branch_id = branch_id
        this.course = course
        this.course_ids= course_ids
        this.end_date = this.endDate
        this.gift = gift
        this.id = id
        this.is_center = is_center
        this.is_flash_sale = typeCode
        this.name = this.nameCode
        this.start_date = this.startDate
        this.type = type
        this.value = value
        this.program_id = program_id
        this.payment_deadline = payment_deadline ?? null
        this.payment_value = payment_value ?? null
        this.truong_hoc =  truong_hoc
        this.installment_fee_payer = installment_fee_payer ?? null
        this.installment_fee = installment_fee ?? null
        this.discount_method = discount_method ?? null
        this.course_discount = course_discount ?? null
        this.disabled = false
        this.disabled_reason = ''
    }
}
